import { render } from "./TestReportSkinInside.vue?vue&type=template&id=1b5db921&scoped=true&ts=true"
import script from "./TestReportSkinInside.vue?vue&type=script&lang=ts"
export * from "./TestReportSkinInside.vue?vue&type=script&lang=ts"

import "./TestReportSkinInside.vue?vue&type=style&index=0&id=1b5db921&scoped=true&lang=css"
import "./TestReportSkinInside.vue?vue&type=style&index=1&id=1b5db921&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5db921"]])

export default __exports__